import React from "react"

// components
import { Button, Tooltip } from "@quorumus/plum"
import { Icon } from "@/components/Icon"
import { DropdownListItem, FilterButton } from "quorumdesign"
import { SearchViewToggle } from "app/static/frontend/search-new/components/FilterableListView/SearchActionButtons/style"

// styles
import classes from "app/static/frontend/search-new/components/FilterableListView/ActionButton.module.css"

// constants
import searchConstants from "app/static/frontend/search-new/constants"

interface ActionButtonProps {
    action: () => void
    activeLabel: string
    dataCy: string
    // whether or not the DropdownListItem is currently active through updateFilter
    // updateFilter(...)
    // shared/search/action-creators.js
    // selectFilterValue: ...,
    // shared/search/selectors.js
    // app/static/frontend/search-new/containers/FilterableListView/ActionButtons.js
    dropdownListItemIsActive?: boolean
    fa5_icon: string
    fa5_icon_family: string
    href: string
    // whether or not the Button (DropdownItem or Button) is currently active through setActiveActionButton
    // setActiveActionButton(...)
    // shared/search/components/FilterableListView/ActionButton.js
    // isActive: ...,
    // shared/search/containers/FilterableListView/ActionButtonContainer.js
    isActive: boolean
    isDropdownItem: boolean
    isProfile: boolean
    label: string
    shortLabel?: string
    tooltipText?: string
    isToggle: boolean
    menuOptions: string[]
    selectedIndex: number
}

export const ActionButton = (props: ActionButtonProps) => {
    const defaultProps = {
        action: () => null,
        icon: "fa-line-chart",
        isActive: false,
        label: "Filler Button",
    }

    const {
        action,
        activeLabel,
        dataCy,
        dropdownListItemIsActive,
        fa5_icon,
        fa5_icon_family,
        href,
        isActive,
        isDropdownItem,
        isProfile,
        label,
        shortLabel,
        tooltipText,
        isToggle,
        menuOptions,
        selectedIndex,
    } = { ...defaultProps, ...props }

    const renderButton = () => {
        const buttonComponent = (
            <Button
                aria-label={shortLabel || (isActive ? activeLabel : label)}
                className={classes.button}
                data-cy={dataCy}
                data-plum-id={dataCy}
                leftSection={<Icon className={classes.icon} icon={fa5_icon} iconFamily={fa5_icon_family} />}
                onClick={action}
                variant={isActive ? "accent" : "tertiary"}
            >
                <span className={classes.label}>{shortLabel || (isActive ? activeLabel : label)}</span>
            </Button>
        )

        if (tooltipText) {
            return (
                <Tooltip label={tooltipText} position="top">
                    {buttonComponent}
                </Tooltip>
            )
        }

        return buttonComponent
    }

    const renderDropdownItem = () => (
        <DropdownListItem
            dataCy={dataCy}
            // this might not exist yet for SearchActionButtons
            href={href}
            icon={fa5_icon}
            iconFamily={fa5_icon_family}
            isActive={dropdownListItemIsActive || isActive}
            onClick={action}
            text={isActive ? activeLabel : label}
            type="primary"
        />
    )

    const renderToggle = () => (
        <SearchViewToggle>
            <FilterButton
                isTiny
                selectedIndex={selectedIndex}
                menuOptions={menuOptions}
                leftIconFixedWidth={false}
                leftIconBreakpoint={
                    isProfile
                        ? searchConstants.PROFILE_HIDE_ICON_BREAKPOINT
                        : searchConstants.SEARCH_HIDE_ICON_BREAKPOINT
                }
                textBreakpoint={
                    isProfile
                        ? searchConstants.PROFILE_HIDE_TEXT_BREAKPOINT
                        : searchConstants.SEARCH_HIDE_TEXT_BREAKPOINT
                }
            />
        </SearchViewToggle>
    )

    if (isToggle) {
        return renderToggle()
    }

    return isDropdownItem ? renderDropdownItem() : renderButton()
}
